// lib/http/api.js
import { createClientService } from './client';

class ApiService {
    constructor(openLoginHandler) {
        this.client = createClientService(openLoginHandler);
        this.openLoginHandler = openLoginHandler;
    }

    async request(method, apiName, data, config, retryCount = 0) {

        // 新增：重试限制（防止死循环）
        if (retryCount > 2) throw new Error("Max retries exceeded");

        try {
            if (method === 'get') {
                return await this.client.get(apiName, data, config);
            } else {
                return await this.client.post(apiName, data, config);
            }
        } catch (error) {
            console.log("🚀 ~ ApiService ~ request ~ error:", error)
            if (error?._handled) throw error; // 跳过已处理的错误
            if (error?.code === 'user_need_login_token_invalid') {
                try {
                    await this.openLoginHandler();
                    return this.request(method, apiName, data, config, retryCount + 1); // 递归调用，增加重试计数
                } catch (loginError) {
                    // 新增：处理登录被取消的情况
                    console.log("Login failed or canceled", loginError);
                    if (loginError.message.includes('canceled')) {
                        throw new Error('Login canceled by user');
                    }
                    throw loginError; // 抛出错误中断流程
                }

            }
            throw error;
        }
    }

    async authRequest(method, apiName, data, config) {
        return this.request(method, apiName, data, config);
    }
}

// 创建 React hook
export const createApiHook = (openLoginHandler) => {
    const apiService = new ApiService(openLoginHandler);

    return {
        get: (apiName, params, config) => apiService.request('get', apiName, params, config),
        post: (apiName, data, config) => apiService.request('post', apiName, data, config),
        authGet: (apiName, params, config) => apiService.authRequest('get', apiName, params, config),
        authPost: (apiName, data, config) => apiService.authRequest('post', apiName, data, config)
    };
};